import { debounce } from 'lodash';
import { SearchResponse } from '@models';
import { autocompleteService, searchService } from '@services';
import { AutocompleteComponent } from '../autocomplete/autocomplete.component';
import { BaseComponent } from '../base.component';
import defaultHtml from './search.component.hbs';

export class SearchComponent extends BaseComponent<SearchResponse> {
    protected override bindEvent = 'hawksearch:bind-search';
    protected override customTemplatePropertyName = 'search';
    protected override defaultHtml = defaultHtml;

    private clickEventHandler!: (event: MouseEvent) => void;

    override connectedCallback(): void {
        super.connectedCallback();

        this.clickEventHandler = (event: Event): void => {
            const element = event.target as HTMLElement;
            const searchElement = !!element.closest('hawksearch-search');

            if (!searchElement) {
                this.toggleAutocomplete(false);
            }
        };

        this.shadowRoot?.ownerDocument.addEventListener('click', this.clickEventHandler);
    }

    disconnectedCallback(): void {
        super.disconnectedCallback();

        this.shadowRoot?.ownerDocument.removeEventListener('click', this.connectedCallback);
    }

    protected getContentHtml(template: HandlebarsTemplateDelegate): string {
        const html = template({
            ...this.data
        });

        return html;
    }

    protected bindChildElements(): void {
        const enterKeys = ['Enter', 'NumpadEnter'];

        this.shadowRoot?.querySelectorAll('[hawksearch-search-input]').forEach((e) => {
            e.addEventListener('keyup', ((event: KeyboardEvent): void => {
                if (!enterKeys.includes(event.code)) {
                    return;
                }

                const element = event.currentTarget as HTMLInputElement;
                const query = element.value.trim();

                this.toggleAutocomplete(false);

                searchService.query(query);
            }) as EventListener);

            const onKeyUp = (event: KeyboardEvent): void => {
                if (enterKeys.includes(event.code)) {
                    return;
                }

                const element = e as HTMLInputElement; // Not using event.currentTarget as that gets lost when using lodash debounce
                const query = element.value.trim();

                this.toggleAutocomplete(!!query);

                if (query) {
                    autocompleteService.query(query);
                }
            };

            e.addEventListener('keyup', debounce(onKeyUp, 300) as unknown as EventListener);
        });

        this.shadowRoot?.querySelectorAll('hawksearch-autocomplete').forEach((e) => {
            e.addEventListener('hawksearch:close-autocomplete', (event: Event) => {
                this.toggleAutocomplete(false);
            });
        });
    }

    private toggleAutocomplete(visible: boolean): void {
        this.shadowRoot?.querySelectorAll('hawksearch-autocomplete').forEach((e) => {
            const component = e as AutocompleteComponent;

            component.style.display = visible ? 'block' : 'none';
        });
    }
}
